import { getApps, initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const firebaseReady = Boolean(config.apiKey && config.authDomain && config.projectId && config.appId);

export function firebaseAuth() {
  const app = getApps()[0] || initializeApp(config);
  const auth = getAuth(app);
  auth.languageCode = "en";
  return auth;
}

let verifier = null;
export function getRecaptcha(containerId) {
  if (verifier) return verifier;
  verifier = new RecaptchaVerifier(firebaseAuth(), containerId, { size: "invisible" });
  return verifier;
}

export function resetRecaptcha() {
  try { verifier?.clear(); } catch (_) { /* noop */ }
  verifier = null;
}

// Normalises Indian numbers to E.164 (+91XXXXXXXXXX)
export function toE164India(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  const local = digits.length > 10 ? digits.slice(-10) : digits;
  return /^[6-9]\d{9}$/.test(local) ? `+91${local}` : null;
}

export async function sendOtp(phoneE164, containerId) {
  const confirmation = await signInWithPhoneNumber(firebaseAuth(), phoneE164, getRecaptcha(containerId));
  return confirmation;
}
